import { action } from 'mobx';
import { ChainedSchema } from '../general/ChainedSchema';
import { runtime } from '../../../../classes/runtime/Runtime';
class SerializrType_deserializeAsAction extends ChainedSchema {
    constructor(propSchema) {
        super(propSchema);
    }
    deserializer(context) {
        if (runtime.runtimeMobx.isCurrentlyComputingDerivation) {
            runtime.runtimeMobx.unstableStateCount++;
            setTimeout(action(() => {
                const deserialized = this.parentSchema.deserializer(context);
                if (deserialized !== Symbol.for('do_not_assign')) {
                    context.objectContext.target[context.propName] = deserialized;
                }
                runtime.runtimeMobx.unstableStateCount--;
            }));
            return Symbol.for('do_not_assign');
        }
        return this.parentSchema.deserializer(context);
    }
}
export function deserializeAsAction(propSchema) {
    return new SerializrType_deserializeAsAction(propSchema);
}
